var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":{ name: 'Workflow', params:{ workflowName: _vm.scope.row.name }}}},[_vm._v("\n  "+_vm._s(_vm.scope.row.name)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }